import moment from 'moment/moment';
import React, { useState } from 'react';

import BottomPopupDropdownOptions from '@components/BottomPopupDropdownOptions';
import LoaderComponent from '@components/LoaderComponent';
import { toastError } from '@components/Toast';

import DownloadStickerFabric from '@features/materials/components/DownloadStickerFabric';

import ApiClient from '@lib/apiClient';

import { FAVOURITES, MATERIALS, whichUserMaterialEditAndDuplicateAndDeleteCheck } from '@utils/MaterialsUtil';
import { convertDateToLocal, downloadBlobFIle, printApiError } from '@utils/Util';

const DOWNLOAD_OPTIONS = [
	{ id: 'A1', title: 'Fabric Sticker', value: 'FABRIC_STICKER_DOWNLOAD' },
	{ id: 'A2', title: 'Excel Summary Report', value: 'DOWNLOAD_REPORT' }
];

const DownloadSticker = ({
	selectedMaterialIdList,
	setSelectedMaterialIdList,
	count,
	params,
	callback,
	setSelectedMaterialList,
	stickerModelName,
	object,
	selectedMaterialListForSticker,
	setSelectedMaterialListForSticker,
	handleSelectAllMaterial,
	isAllCheckedButtonClicked,
	visibleDataCount,
	doMaterialsMarkAsLowQty,
	parentComponent,
	materialResponse,
	setMaterialsDataList,
	favouriteMaterialApiCalling,
	setAllFavouritesForMaterials
}) => {
	const [loading, setIsLoading] = useState(false);
	const [isDownloadModel, setIsDownloadModel] = useState(false);
	const [itemList, setItemList] = useState([]);
	const [hasSelectedFirstBatch, setHasSelectedFirstBatch] = useState(false);

	const handleSelectFromBottomPopup = () => {
		if (!materialResponse?.data?.length) return;

		setSelectedMaterialListForSticker(materialResponse?.data);
		setSelectedMaterialList(materialResponse?.data);

		const materialIds = materialResponse.data.map((item) => item.materialId);
		setSelectedMaterialIdList((prev) => {
			const uniqueIds = [...new Set([...prev, ...materialIds])];
			return uniqueIds;
		});

		setHasSelectedFirstBatch(true);
	};

	const selecteItemModifiy = () => {
		let items = selectedMaterialListForSticker?.map((item) => {
			return {
				materialId: item.materialId,
				docUrl: item.docUrl,
				referenceNumber: item.referenceNumber,
				supplierName: item.supplierName,
				supplierRefNumber: item.supplierRefNumber,
				stickerQuantity: 1,
				date: convertDateToLocal(moment().format('DD MMM, YY'), 'DD MMM, YY'),
				buyerName: null,
				toggle: true
			};
		});

		setItemList(items);
	};
	const handleDownload = (type) => {
		if ((stickerModelName === MATERIALS || stickerModelName === FAVOURITES) && type === 'sticker') {
			selecteItemModifiy();
			setIsDownloadModel(true);
			return;
		}
		setIsLoading(true);
		let requestParams = '';
		if (params !== null) {
			requestParams = params;
		} else {
			requestParams = `?materialIdList=${selectedMaterialIdList.join(',')}`;
		}
		let url = 'downloadMaterialStickers';
		if (type === 'excel') {
			url = 'downloadMaterialsExcel';
		}
		if (type === 'excel') {
			ApiClient.DOWNLOAD(url, requestParams, '')
				.then((response) => {
					downloadBlobFIle(response);
					setIsLoading(false);
				})
				.catch(({ response }) => {
					setIsLoading(false);
					toastError(response.data.message);
				});
		} else {
			ApiClient.POST(url, requestParams)
				.then((response) => {
					window.open(response.data, '_parent');
					setIsLoading(false);
				})
				.catch(({ response }) => {
					setIsLoading(false);
					toastError(response.data.message);
				});
		}
	};

	const closeModel = () => {
		setIsDownloadModel(false);
	};

	const handleUnSelectAll = () => {
		setSelectedMaterialIdList([]);
		if (stickerModelName === MATERIALS) {
			setSelectedMaterialList([]);
			setSelectedMaterialListForSticker([]);
		}
		callback();
	};

	const handleDownloadOption = (type) => {
		if (type === 'FABRIC_STICKER_DOWNLOAD') {
			handleDownload('sticker');
		} else if (type === 'DOWNLOAD_REPORT') {
			handleDownload('excel');
		}
	};

	const isDisabledSelectNext = () => {
		return materialResponse?.totalElements === selectedMaterialIdList.length;
	};

	const handleBulkUnlike = async () => {
		try {
			setIsLoading(true);
			const { data } = await ApiClient.POST('bulkUnlikeMaterials', selectedMaterialIdList);
			if (data?.success) {
				setSelectedMaterialIdList([]);
				setSelectedMaterialListForSticker([]);
				setSelectedMaterialList([]);
				favouriteMaterialApiCalling();
				setMaterialsDataList((prev) => ({
					...prev,
					data: materialResponse?.data.filter(
						(item) => !selectedMaterialIdList.includes(item?.materialId)
					)
				}));
				setAllFavouritesForMaterials((prev) => ({
					...prev,
					totalElements: prev.totalElements - selectedMaterialIdList?.length,
					data: materialResponse?.data.filter(
						(item) => !selectedMaterialIdList.includes(item?.materialId)
					)
				}));
			}
		} catch (error) {
			printApiError(error);
			setIsLoading(false);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<LoaderComponent loading={loading}>
			{isDownloadModel && (
				<DownloadStickerFabric
					selectedMaterialIdList={selectedMaterialIdList}
					materialDataList={itemList}
					object={object}
					count={itemList.length}
					onclose={closeModel}
				/>
			)}
			{selectedMaterialIdList.length > 0 && (
				<div className="design-count-section bg-white shadow-8dp">
					<div className="count-info d-flex justify-content-between align-items-center">
						<div className="design-count">
							<p className="semibold-18">
								{count}
								{materialResponse?.totalElements ? `/${materialResponse?.totalElements}` : ''}
							</p>
						</div>
						{parentComponent === 'FAVOURITE_MATERIAL' && (
							<button
								className="button text size36"
								onClick={handleSelectFromBottomPopup}
								disabled={isDisabledSelectNext()}
							>
								Select {!hasSelectedFirstBatch ? 'First ' : 'Next '}
								{Math.min(
									30,
									materialResponse?.totalElements - selectedMaterialIdList.length
								)}{' '}
								Items
							</button>
						)}

						{parentComponent !== 'FAVOURITE_MATERIAL' && (
							<div className="buttons ">
								{isAllCheckedButtonClicked ? (
									<button className="button text size36" onClick={handleUnSelectAll}>
										<span className="ml-1">Unselect {visibleDataCount} All</span>
									</button>
								) : (
									<button
										className="button text size36"
										onClick={() => {
											handleSelectAllMaterial('', true);
										}}
									>
										<span className="ml-1">Select {visibleDataCount} All</span>
									</button>
								)}
							</div>
						)}
						{parentComponent === 'FAVOURITE_MATERIAL' && (
							<div className="buttons">
								<button className="button text size36" onClick={handleBulkUnlike}>
									<span className="ml-1">Unfavourite All</span>
								</button>
							</div>
						)}

						{whichUserMaterialEditAndDuplicateAndDeleteCheck() &&
							parentComponent !== 'FAVOURITE_MATERIAL' && (
								<>
									<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
										|
									</span>
									<div className="buttons ">
										<button
											className="button text size36"
											onClick={doMaterialsMarkAsLowQty}
										>
											<span className="ml-1">Mark as Low Qty</span>
										</button>
									</div>
								</>
							)}
						<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
							|
						</span>
						<div>
							<BottomPopupDropdownOptions
								options={DOWNLOAD_OPTIONS}
								onActionClick={handleDownloadOption}
							/>
						</div>
						<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
							|
						</span>
						<div className="text-right close-icon" onClick={handleUnSelectAll}>
							<img
								src={`${process.env.PUBLIC_URL}/icons/close.svg`}
								alt="close"
								className="cursor-pointer"
							/>
						</div>
					</div>
				</div>
			)}
		</LoaderComponent>
	);
};

export default DownloadSticker;
